import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { SideNavigation, SideNavigationProps } from '@amzn/awsui-components-react-v3';

import { FrontEndFeatureSet, useArgoContext } from '@awsscm/argo-core';
import config from '../../config';
// import { moveContainerFeatureFlag } from '../../utils/featureFlags';

export default function Navigation(): ReactElement {
  const argoContext = useArgoContext();
  const { t } = useTranslation();
  // const showMoveContainerTool = moveContainerFeatureFlag();

  // Obtain region to determine which apps to show on sidebar.
  const context = window?.ARGO_CONFIG?.argo;
  const region = context?.region;

  const inventoryManagementItems: Array<SideNavigationProps.Item> = [
    {
      type: 'link',
      text: t('Container Management'),
      href: '/assets-inventory/container/manage',
    },
  ];

  if (argoContext.frontEndFeatureSet !== FrontEndFeatureSet.Release) {
    inventoryManagementItems.push({
      type: 'link',
      text: t('Inventory Move'),
      href: '/assets-inventory/move',
    });
  }

  if (argoContext.frontEndFeatureSet !== FrontEndFeatureSet.Release) {
    inventoryManagementItems.push({
      type: 'link',
      text: t('Parts Move'),
      href: '/assets-inventory/parts-move',
    });
  }

  // if (showMoveContainerTool) {
  //   inventoryManagementItems.push({
  //     type: 'link',
  //     text: t('Inventory Move'),
  //     href: '/assets-inventory/move',
  //   });
  // }

  const links: Array<SideNavigationProps.Item> = [
    {
      type: 'section',
      text: t('Receiving'),
      items: [
        {
          type: 'link',
          text: t('Unified Receive'),
          href: '/inventory-receive/receive',
        },
        {
          type: 'link',
          text: t('Create Exception'),
          href: '/assets-inventory/receive/exception/create',
        },
        {
          type: 'link',
          text: t('Search Exceptions'),
          href: '/assets-inventory/receive/exception/search',
        },
      ],
    },
    {
      type: 'section',
      text: t('Assets'),
      items: [
        {
          type: 'link',
          text: t('PAC Asset Validation'),
          href: '/assets-inventory/asset-validation',
        },
      ],
    },
    {
      type: 'section',
      text: t('Inventory Management'),
      items: inventoryManagementItems,
    },
    { type: 'divider' },
    {
      type: 'link',
      text: t('common.documentation'),
      href: config.documentationLink,
      external: true,
    },
  ];

  const linksCN: Array<SideNavigationProps.Item> = [
    {
      type: 'section',
      text: t('Receiving'),
      items: [
        {
          type: 'link',
          text: t('Unified Receive'),
          href: '/inventory-receive/receive',
        },
        {
          type: 'link',
          text: t('Create Exception'),
          href: '/assets-inventory/receive/exception/create',
        },
        {
          type: 'link',
          text: t('Search Exceptions'),
          href: '/assets-inventory/receive/exception/search',
        },
      ],
    },
    {
      type: 'section',
      text: t('Inventory Management'),
      items: inventoryManagementItems,
    },
  ];

  if (region === 'cn-northwest-1') {
    return <SideNavigation items={linksCN} />;
  } else {
    return <SideNavigation items={links} />;
  }
}
